import validator from "validator";
import message from "../../../../messages/campaign/banner/simple";

const validateName = (name) => {
  if (validator.isEmpty(name)) {
    return message.NAME_DOSE_NOT_EXIST;
  }

  if (!name.trim().length) {
    return message.NAME_DOSE_NOT_EXIST;
  }

  return true;
};

const validateCategoryID = (categoryID) => {
  if (validator.isEmpty(categoryID)) {
    return message.CATEGORY_ID_NOT_EXIST;
  }

  if (!validator.isNumeric(categoryID)) {
    return message.CATEGORY_ID_INVALID;
  }

  return true;
};

const validateActive = (active) => {
  if (validator.isEmpty(active)) {
    return message.ACTIVE_ID_NOT_EXIST;
  }

  if (!validator.isNumeric(active)) {
    return message.ACTIVE_ID_INVALID;
  }

  return true;
};

const validateFormEditCampaign = (info) => {
  const resValidateName = validateName(info.name);
  if (resValidateName != true) {
    return resValidateName;
  }

  const resValidateCategoryID = validateCategoryID(info.category_id);
  if (resValidateCategoryID != true) {
    return resValidateCategoryID;
  }

  const resValidateActive = validateActive(info.active);
  if (resValidateActive != true) {
    return resValidateActive;
  }

  return true;
};

export default validateFormEditCampaign;
